export const TOTAL_DEBITS = {
  prefix: "$",
  value: -1748482.7868,
  suffix: "",
  change: 0,
  changeSuffix: "",
  decimals: 0,
};
